"use strict";

angular.module('PatientApp').controller('TermsOfServiceCtrl', function (VueEventTransmitter, $scope, AuthService, PatientUsersService) {
  $scope.acceptTerms = function () {
    PatientUsersService.acceptTerms();
    $scope.showTerms = false;
  };

  VueEventTransmitter.$on('user:changed', function (user) {
    if (!user.latestTOSVersion && !user.bdLogin) {
      $scope.showTerms = true;
    }
  });
});